import request from '@/libs/request'

// 商品列表
export const goodsList = (data) => {
    return request({
        url: '/commodity/list',
        data,
        method: 'post'
    })
}


// 商品详情
export const goodsDetail = (data) => {
    return request({
        url: '/commodity/queryById',
        data,
        method: 'post'
    })
}


// 用户端我的报名
// status
// 活动状态 1.进行中 2.已完成 3.未开始
export const mySignUp = (data) => {
    return request({
        url: '/signup/mySignUp',
        data,
        method: 'post'
    })
}


// 活动支付
export const actPay = (data) => {
    return request({
        url: '/mobileuser/pay',
        data,
        method: 'post'
    })
}

// 用户签到
export const userSignIn = (data) => {
    return request({
        url: '/mobileuser/signIn',
        data,
        method: 'post'
    })
}


// 收藏操作
export const collectAdd = (data) => {
    return request({
        url: '/usercollection/save',
        data,
        method: 'post'
    })
}


// 收藏列表
export const collectList = (data) => {
    return request({
        url: '/usercollection/list',
        data,
        method: 'post'
    })
}

// 收藏-取消
export const collectCancel = (data) => {
    return request({
        url: '/usercollection/delete',
        data,
        method: 'post'
    })
}


// 活动报名
export const actSignUp = (data) => {
    return request({
        url: '/signup/save',
        data,
        method: 'post'
    })
}

// 积分明细
export const myIntegralList = (data) => {
    return request({
        url: '/integralrecord/mobileUserList',
        data,
        method: 'post'
    })
}



// 虚拟资产明细
export const myAssetsList = (data) => {
    return request({
        url: '/assetsrecord/personList',
        data,
        method: 'post'
    })
}

// 申请退费
export const applyForRefund = (data) => {
    return request({
        url: '/assetsrecord/applyForRefund',
        data,
        method: 'post'
    })
}
// 用户个人退费申请分页查询
export const refundList = (data) => {
    return request({
        url: '/assetsrecord/refundList',
        data,
        method: 'post'
    })
}


// 商品兑换

export const goodsExchange = (data) => {
    return request({
        url: '/mobileuser/exchange',
        data,
        method: 'post'
    })
}

// 商品兑换管理

export const goodsExchangeList = (data) => {
    return request({
        url: '/integralrecord/exchangeList',
        data,
        method: 'post'
    })
}



export function adList(data) {
    return request({
        url: '/ad/list',
        method: 'post',
        data
    })
}



// 转赠积分
export const giveIntegral = (data) => {
    return request({
        url: '/mobileuser/giveIntegral',
        data,
        method: 'post'
    })
}


// 移动端捐赠账户下拉
export const donationPullList = (data) => {
    return request({
        url: '/donation/pullList',
        data,
        method: 'post'
    })
}

export const donateIntegral = (data) => {
    return request({
        url: '/mobileuser/donateIntegral',
        data,
        method: 'post'
    })
}




export const goodsCommodityList = (data) => {
    return request({
        url: '/commodity/exchangeList',
        data,
        method: 'post'
    })
}


// 站内消息
export const ownerList = (data) => {
    return request({
        url: '/message/ownerList',
        data,
        method: 'post'
    })
}


